export default "__VITE_ASSET__9e252438__"